/** @returns {boolean} */
export function isAnalyticsEnabled() {
  const flag = process.env.REACT_APP_ANALYTICS_ENABLED;
  if (flag === 'false' || flag === '0') return false;
  if (flag === 'true' || flag === '1') return true;
  // Default: enabled in production builds when a measurement id is present
  return process.env.NODE_ENV === 'production';
}

/** @returns {string} GA4 measurement ID (G-XXXXXXXXXX). */
export function getGa4MeasurementId() {
  return (process.env.REACT_APP_GA4_MEASUREMENT_ID || '').trim();
}

/** @returns {boolean} */
export function isGa4Configured() {
  const id = getGa4MeasurementId();
  return /^G-[A-Z0-9]+$/i.test(id);
}

/** @returns {boolean} */
export function shouldLoadAnalytics() {
  return isAnalyticsEnabled() && isGa4Configured();
}

/** @returns {boolean} */
export function isAnalyticsDebug() {
  return process.env.NODE_ENV !== 'production'
    && process.env.REACT_APP_ANALYTICS_DEBUG !== 'false';
}
